// Color Configuration - Centrum Fuel Theme
export const COLORS = {
  primary: "#00bbd4",
  primaryDark: "#009fb6",
  primaryLight: "#e0f7fa",
  accent: "#4caf50",
  text: "#1a202c",
  textSecondary: "#6b7280",
  border: "#e0e0e0",
  white: "#ffffff",
  background: "#f8f7f7",
};

// Radius Options for dropdown
export const RADIUS_OPTIONS = [
  { value: 5, label: "5 KM" },
  { value: 15, label: "15 KM" },
  { value: 50, label: "50 KM" },
  { value: 100, label: "100 KM" },
  { value: 200, label: "200 KM" },
  { value: 400, label: "400 KM" },
];

// Map Configuration
export const PHILIPPINES_CENTER = [121.774, 12.8797];
export const PHILIPPINES_BOUNDS = [
  [116.0, 4.5],
  [127.0, 21.5],
];

// Nominatim free geocoding (OpenStreetMap)
export const geocodeLocation = async (query) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?` +
        new URLSearchParams({
          q: `${query}, Philippines`,
          format: "json",
          limit: "1",
          countrycodes: "ph",
        }),
      {
        headers: {
          "User-Agent": "CentrumFuelStationFinder/1.0",
        },
      }
    );

    const data = await response.json();

    if (data && data.length > 0) {
      return {
        lat: data[0].lat,
        lon: data[0].lon,
        display_name: data[0].display_name,
      };
    }
    return null;
  } catch (error) {
    console.error("Geocoding error:", error);
    return null;
  }
};

// Get Google Maps URL for a station
export const getGoogleMapsUrl = (station) => {
  if (station.lat && station.lon) {
    return `https://www.google.com/maps?q=${station.lat},${station.lon}`;
  } else if (station.location) {
    return `https://www.google.com/maps?q=${encodeURIComponent(station.location)}`;
  }
  return "#";
};